import { Tabs } from "//decked.com/cdn/shop/t/428/assets/static.theme.js?v=47654765608148717691769207021";
import { RichTextProcessor, capitalize } from "//decked.com/cdn/shop/t/428/assets/static.vpv-utils.js?v=167898115859071125761768345860";

var PdpTabs = class extends Tabs {
  constructor() {
    super();

    this.panelTemplate = this.querySelector("#pdp-tab").content;
    this.unselectedTemplate = this.querySelector("#pdp-tabs-unselected").content;

    this.selectors = {
      dimensions: 'div[data-panel-title="dimensions-and-capacities"]',
      importantNotes: 'div[data-panel-title="important-notes"]',
    };
    this.unitsMap = {
      yards: "yd",
      meters: "m",
      centimeters: "cm",
      millimeters: "mm",
      inches: "in",
      feet: "ft",
      pounds: "lbs",
      ounces: "oz",
      grams: "g",
      kilograms: "kg",
      liters: "L",
    };
    this.specKeys = {
      specs: ["extension", "payload", "drawer_payload", "volume", "weight", "weight_with_ladder"],
      system_dimensions: ["length", "width", "height", "tray_length", "tray_width", "tray_height"],
      drawer_dimensions: ["drawer_length_top", "drawer_length_bottom", "drawer_width_top", "drawer_width_bottom", "drawer_2_length_top", "drawer_2_length_bottom", "drawer_2_width_top", "drawer_2_width_bottom", "drawer_clearance", "drawer_extension"],
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this.renderUnselectedState();
    window.addEventListener("vehicleSelected", e => {
      this.renderUnselectedState();
    });

    window.addEventListener("variantSelected", e => {
      const { detail } = e;
      const techNotesHtml = this.getNotesNode(detail);
      const techSpecsHtml = this.getSpecsNode(detail.variantTechSpecs);
      this.updatePanel(this.selectors.importantNotes, techNotesHtml);
      this.updatePanel(this.selectors.dimensions, techSpecsHtml);
    });
  }

  renderUnselectedState() {
    const storedVehicle = localStorage.getItem("selectedVehicle");
    const vehicleTitle = storedVehicle && JSON.parse(storedVehicle)?.title ? JSON.parse(storedVehicle)?.title : null;
    const linkText = vehicleTitle || "Your Vehicle";

    const unselectedTemplate = this.unselectedTemplate.cloneNode(true);
    const unselectedPanel = unselectedTemplate.querySelector('.pdp-tabs__unselected');
    const vehicleEl = unselectedPanel.querySelector('.pdp-tabs__unselected__vehicle');
    vehicleEl.innerHTML = linkText;

    this.updatePanel(this.selectors.importantNotes, unselectedPanel);
    this.updatePanel(this.selectors.dimensions, unselectedPanel.cloneNode(true));
  }

  getSpecsNode(specObj) {
    const { fields, imageData } = specObj.reference;
    const panelTemplate = this.panelTemplate.cloneNode(true);
    const specsPanel = panelTemplate.querySelector(".pdp-tab");
    specsPanel.classList.add("pdp-tab--specs");
    const col1 = specsPanel.querySelector(".pdp-tab__col:first-child");
    const col2 = specsPanel.querySelector(".pdp-tab__col:last-child");

    // Add Image
    if (imageData) {
      const { image } = imageData.reference;
      const img = document.createElement("img");
      img.src = image.url;
      img.altText = image.altText;
      col2.append(img);
    }

    // Create Spec Sections
    const sections = {
      specs: document.createElement("div"),
      system_dimensions: document.createElement("div"),
      drawer_dimensions: document.createElement("div"),
    };

    const techSpecsOrder = Object.values(this.specKeys).flat(1)

    const compare = (a, b) => {
      const indexA = techSpecsOrder.indexOf(a.key);
      const indexB = techSpecsOrder.indexOf(b.key);
      if (indexA < indexB) {
        return -1;
      } else if (indexA > indexB) {
        return 1;
      } else {
        return 0;
      }
    };

    const sortedData = fields.sort(compare);

    sortedData.forEach(field => {
      if (field.key === "image") return;

      const fieldNode = document.createElement("div");
      fieldNode.classList.add("pdp-tab__spec");

      const nameString = window.themeVariables.strings[specObj.reference.type] && window.themeVariables.strings[specObj.reference.type][field.key];
      const name = document.createElement("span");
      name.innerHTML = `${nameString ? nameString : capitalize(field.key.replace(/\_/g, " "))}:&nbsp;`;
      name.classList.add("text-subdued");

      const content = document.createElement("span");

      if (field.value.includes(`"value"`)) {
        const valueJson = JSON.parse(field.value);
        const value = valueJson.value;
        const unit = this.unitsMap[valueJson.unit.toLowerCase()] || valueJson.unit || "";
        content.innerHTML = `${value}${unit}`;
      } else {
        content.innerHTML = field.value;
      }

      fieldNode.append(name, content);

      // Add field to section based on specKey map
      Object.keys(sections).forEach(sectionKey => {
        // console.log('spec key', sectionKey, field.key)
        if (this.specKeys[sectionKey].includes(field.key)) {
          const section = sections[sectionKey];
          if (!section.children.length) {
            // If section doesn't have fields, add title first
            section.classList.add("pdp-tab__section");
            const sectionTitle = document.createElement("span");
            sectionTitle.classList.add("bold");
            sectionTitle.innerHTML = sectionKey.replace(/\_/g, " ");
            section.append(sectionTitle, fieldNode);
          } else {
            section.append(fieldNode);
          }
        }
      });

      // Add section if it has fields
      Object.keys(sections).forEach(sectionKey => {
        const section = sections[sectionKey];
        if (section.children.length) {
          col1.append(section);
        }
      });
    });

    return specsPanel;
  }

  getNotesNode(detail) {
    const { variantCompatible, variantNotCompatible, variantTechNotes } = detail;
    const panelTemplate = this.panelTemplate.cloneNode(true);
    const notesPanel = panelTemplate.querySelector(".pdp-tab");
    notesPanel.classList.add("pdp-tab--notes");
    const col1 = notesPanel.querySelector(".pdp-tab__col:first-child");
    const col2 = notesPanel.querySelector(".pdp-tab__col:last-child");
    const notesAdditional = this.getNotesAdditional(variantTechNotes);
    const notesCompatible = this.getNotesCompatibility(variantCompatible, "COMPATIBLE WITH:");
    const notesNotCompatible = this.getNotesCompatibility(variantNotCompatible, "NOT COMPATIBLE WITH:");

    notesAdditional && col1.append(notesAdditional);
    notesCompatible && col2.append(notesCompatible);
    notesNotCompatible && col2.append(notesNotCompatible);
    notesPanel.append(col1, col2);
    return notesPanel;
  }

  getNotesCompatibility(compatArray, sectionTitle) {
    if (!compatArray) return;
    const compatSection = document.createElement("div");
    compatSection.classList.add("pdp-tab__section");
    compatSection.innerHTML = `
      <span class="pdp-tab__section__title"><b>${sectionTitle}</b></span>
      <ul>
        ${compatArray.reduce((acc, compatObj) => {
          return `${acc}
            <li>
              <span>${compatObj.title}</span>${compatObj.link ? `&nbsp;<a href="${compatObj.link}" class="text-subdued">Learn more</a>` : ""}
            </li>
          `;
        }, "")}
      </ul>
    `;
    return compatSection;
  }

  getNotesAdditional(notesArray) {
    const notesSection = document.createElement("div");
    notesArray.forEach(noteObj => {
      const richText = RichTextProcessor.toNode(noteObj.note);
      const note = document.createElement("div");
      note.classList.add("pdp-tab__section");
      note.append(richText);
      notesSection.append(note);
    });
    return notesSection;
  }

  updatePanel(selector, newContent) {
    this.querySelector(selector).replaceChildren(newContent);
    // NOTE: Mobile Accordion lives outside Tabs component :(
    document.querySelector(`.tabs-container ${selector}`).replaceChildren(newContent.cloneNode(true));
  }
};
if (!window.customElements.get("pdp-tabs")) {
  window.customElements.define("pdp-tabs", PdpTabs);
}
